<template>
    <v-modal-slot id="show-attorneys-modal"
                  @closed="closeModal">
        <template v-slot:modal-title>
            Información del procurador
        </template>

        <template v-slot:modal-content>
            <div class="row pb-3">
                <div class="col-6">
                    <strong>Nombre: </strong><br/><span>{{ attorney.name }}</span>
                </div>

                <div class="col-6">
                    <strong>Apellidos:</strong><br/><span>{{ attorney.surname }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <strong>DNI:</strong><br/><span>{{ attorney.dni }}</span>
                </div>

                <div class="col-4">
                    <strong>Número de colegiado:</strong><br/><span>{{ attorney.collegiate_number }}</span>
                </div>

                <div class="col-4">
                    <strong>Colegio:</strong><br/><span>{{ attorney.college }}</span>
                </div>
            </div>
        </template>
    </v-modal-slot>
</template>

<script>
import VModal from "../../general/VModal";
import VModalSlot from "../../general/VModalSlot";

export default {
    name: "AttorneysListShowModal",
    components: {VModalSlot, VModal},
    props: {
        attorney: {
            type: Object,
            required: true,
        }
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
